import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseBoolean',
  pure: true,
})
export class ParseBooleanPipe implements PipeTransform {
  transform(value: string, defaultValue: boolean) {
    if (typeof value == 'string' && !!value?.length) {
      if (['yes', 'true'].includes(value.trim().toLowerCase())) {
        return true;
      } else if (['no', 'false'].includes(value.trim().toLowerCase())) {
        return false;
      } else if (typeof value == 'boolean') {
        return value;
      }
    }
    return defaultValue;
  }
}
